export default "__VITE_ASSET__Da7Mq2GO__"